import { useEffect } from 'react';
import { registerModal } from '@/shared/utils/nativeBridge';

/**
 * Render inside the content of a drawer, sheet or dialog primitive. The content
 * only mounts while the overlay is open, so mounting reports "a modal is on
 * screen" to the native app (`WEB_STATE`) and unmounting withdraws the report.
 * The app decides what to do with its bottom bar (rule in `nativeBridge.ts`);
 * in a browser this does nothing.
 *
 * Default rule: build every drawer, sheet, dialog or modal on the shared
 * `Drawer`, `Sheet`, `Dialog` or `Modal` components, which render this for you,
 * so the app hides its bottom bar with no per-screen code. Only a hand-rolled
 * overlay the user interacts with needs this rendered inside it by hand.
 * Popovers and decorative layers (confetti, transitions) must not report.
 */
const ReportOverlayToApp = () => {
	useEffect(() => registerModal('sheet'), []);
	return null;
};

export default ReportOverlayToApp;
